'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Proxy provides a means for specifying a proxy server

var Proxy = function Proxy(url) {
  _classCallCheck(this, Proxy);

  if (url) {
    this.url = url;
  } else {
    var defaultUrl = 'http://localhost:8888';

    console.log('Proxy() - using default proxy "' + defaultUrl + '"');

    this.url = defaultUrl;
  }
};

module.exports = Proxy;


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/resource/lib/proxy.js
// module id = 372
// module chunks = 4